import { RouterProvider } from '@tanstack/react-router';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Toaster } from '@/components/ui/sonner';
import { router } from '@/router';
import { useIsAuthenticated } from '@/services/auth';

export function AppProvider() {
  const auth = useIsAuthenticated();

  return (
    <HelmetProvider>
      <Helmet>
        <meta
          http-equiv="Content-Security-Policy"
          content="default-src * 'unsafe-inline' 'unsafe-eval' data: blob:;"
        />
      </Helmet>
      <Toaster position="bottom-center" closeButton duration={3000} />
      <RouterProvider
        router={router}
        context={{
          auth,
        }}
      />
    </HelmetProvider>
  );
}
